"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
var React = require("react");
var styled_components_1 = require("styled-components");
var core_1 = require("../core");
var is_1 = require("../helper/is");
var number_1 = require("./number");
var hex_1 = require("./hex");
var hsl_1 = require("./hsl");
var unit_1 = require("./unit");
var step_1 = require("./step");
var boxShadow_1 = require("./boxShadow");
var borderRadius_1 = require("./borderRadius");
var cubicBezier_1 = require("./cubicBezier");
exports.modular = function (value, range, easing, transform) { return function (props) {
    var theme = props.theme;
    var ranges = core_1.getRange(range, theme);
    if (is_1.is.number(ranges[0])) {
        return number_1.number(value, ranges, easing, transform)({ theme: theme });
    }
    if (is_1.is.hex(ranges[0])) {
        return hex_1.hex(value, ranges, easing)({ theme: theme });
    }
    if (is_1.is.hsl(ranges[0])) {
        return hsl_1.hsl(value, ranges, easing);
    }
    if (is_1.is.boxShadow(ranges[0])) {
        return boxShadow_1.boxShadow(value, ranges, easing)({ theme: theme });
    }
    if (is_1.is.borderRadius(ranges[0])) {
        return borderRadius_1.borderRadius(value, ranges, easing)({ theme: theme });
    }
    if (is_1.is.cubicBezier(ranges[0])) {
        return cubicBezier_1.cubicBezier(value, ranges, easing)({ theme: theme });
    }
    if (is_1.is.unit(ranges[0])) {
        return unit_1.unit(value, ranges, easing, transform)({ theme: theme });
    }
    return step_1.step(value, ranges)({ theme: theme });
}; };
exports.useModular = function (value, range, easing, transform) {
    var theme = React.useContext(styled_components_1.ThemeContext);
    return exports.modular(value, range, easing, transform)({ theme: theme });
};
//# sourceMappingURL=modular.js.map